// extracted by mini-css-extract-plugin
module.exports = {"title":"WorkSection_title__HX9Vo","description":"WorkSection_description__FXx_l"};